export default __webpack_public_path__ + "static/media/waterBuffalo.b62c7d3c.jpg";